import {Typography} from 'components/Typography';
import classNames from 'classnames';
import React, {FC, useEffect, useState} from 'react';
import style from './style.module.scss';
import {FilterCustomViewType} from 'plugins/modules/filter/types';

export interface IProps {
    count?: number;
    isDefaultChecked: boolean;
    onChange: (isChecked: boolean) => void;
    title: string;
}

export const Chips: FC<IProps> = ({count, isDefaultChecked, onChange, title}) => {
    const [currentIsDefaultChecked, setCurrentIsDefaultChecked] = useState(isDefaultChecked);
    const [isChecked, setIsChecked] = useState(isDefaultChecked);

    useEffect(() => {
        if (currentIsDefaultChecked === isDefaultChecked) {
            return;
        }

        setCurrentIsDefaultChecked(isDefaultChecked);
        setIsChecked(isDefaultChecked);
    }, [currentIsDefaultChecked, isDefaultChecked]);

    const handleChange = () => {
        const value = !isChecked;

        setIsChecked(value);
        onChange(value);
    };

    // реализация хардкора как на проде
    const view: FilterCustomViewType.GIFT | null =
        'в подарок' === title.toLowerCase() ? FilterCustomViewType.GIFT : null;

    return (
        <label
            data-skeleton-item={true}
            className={classNames(style.main, {[style.isChecked]: isChecked, [style.withImage]: view})}
        >
            {view && <img alt={''} className={style.image} src={`/images/${view}.png`} />}
            <input checked={isChecked} className={style.checkbox} onChange={handleChange} type={'checkbox'} />
            <Typography className={style.content} variant={'label-14-r'}>
                {title}
            </Typography>
            {'number' === typeof count && (
                <Typography className={style.count} variant={'label-14-r'}>
                    {count}
                </Typography>
            )}
        </label>
    );
};
